export default function ParagraphRenderer({ section }){

    return <p>{section.value}</p>;

}